module.exports = __webpack_public_path__ + "img/slide-instant-order-gr.7ec2562c.png";